import { gql } from '@apollo/client';

export const GET_ARTICULO_ID = gql`
  {
    getArticuloId @client
  }
`;

export const GET_ARTICULO = gql`
  query getArticulo($id: ID!) {
    getArticulo(id: $id) {
      _id
      titulo
      autor
      resumen
      contenido
      descripcionAutor
      comentarios {
        _id
      }
      etiquetas
    }
  }
`;

export const GET_ARTICULOS = gql`
  query getArticulos($paginate: getArticulosPaginate!) {
    getArticulos(paginate: $paginate) {
      articulos {
        node {
          _id
          titulo
          autor
          resumen
          contenido
          descripcionAutor
          comentarios {
            _id
          }
          etiquetas
        }
        cursor
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
`;

export const SEARCH_ARTICULOS = gql`
  query searchArticulos($paginate: searchArticulosPaginate!) {
    searchArticulos(paginate: $paginate) {
      articulos {
        node {
          _id
          titulo
          autor
          resumen
          contenido
          descripcionAutor
          comentarios {
            _id
          }
          etiquetas
        }
        cursor
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
`;

export const ADD_ARTICULO = gql`
  mutation createArticulo($input: CreateArticuloInput!) {
    createArticulo(input: $input) {
      _id
      titulo
      autor
      resumen
      contenido
      descripcionAutor
      comentarios {
        _id
      }
      etiquetas
      code
      success
      message
    }
  }
`;

export const UPDATE_ARTICULO = gql`
  mutation updateArticulo($input: UpdateArticuloInput) {
    updateArticulo(input: $input) {
      _id
      titulo
      autor
      resumen
      contenido
      descripcionAutor
      comentarios {
        _id
      }
      etiquetas
      code
      success
      message
    }
  }
`;

export const REMOVE_ARTICULO = gql`
  mutation removeArticulo($input: DeleteArticuloInput!) {
    removeArticulo(input: $input) {
      code
      success
      message
    }
  }
`;
